import { Component, Input } from '@angular/core';
import { BasketAddress } from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

@Component({
    selector: 'address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})
export class AddressComponent {
    @Input() address: BasketAddress | undefined;
    @Input() highlight = '';
    /**
     * EPROC-11920: off where the contact person is already shown next to the address — in the
     * contact-only mode of the basket address dialog it is an editable field of its own, so
     * repeating it here would show it twice, and from a snapshot taken when the dialog opened.
     */
    @Input() showContact = true;
}
